import { create } from "zustand";

export const useStore = create((set) => ({
    Collapsed: window.innerWidth >= 1000 ? false : true,
    setCollapsed: (collapsed: boolean) =>
        set((state: any) => ({ ...state, Collapsed: collapsed })),
    sideNavStatus:
        localStorage.getItem("main_status") == "client_review" ||
        localStorage.getItem("main_status") == "e_filing",
    setSidenavStatus: (collapsed: boolean) =>
        set((state: any) => ({ ...state, sideNavStatus: collapsed })),
    mainStatus: localStorage.getItem("main_status"),
    setmainStatus: (collapsed: any) =>
        set((state: any) => ({ ...state, mainStatus: collapsed })),
    setSelectedYear: (collapsed: any) =>
        set((state: any) => ({ ...state, SelectedYear: collapsed })),
    currentYear: new Date().getFullYear(),
    isDisabled:
        new Date().getFullYear().toString() !=
            localStorage.getItem("selectedYear") &&
        (new Date().getFullYear() - 1).toString() !=
            localStorage.getItem("selectedYear"),
    setIsDisabled: (disable: boolean) =>
        set((state: any) => ({ ...state, isDisabled: disable })),
    SelectedYear:
        localStorage.getItem("selectedYear") || new Date().getFullYear(),
}));
